export default __webpack_public_path__ + "static/media/culture_EP9.34c879f0.png";